export default __webpack_public_path__ + "static/media/close_light.27ab7e6f.svg";